import 'rxjs/Rx';

import { HttpClient, HttpClientModule } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class InternalLoggerService {

    constructor(private http: HttpClient) { }

    updateAuditLogger(data) {
        return this.http.post(`/api/internalLogger/updateAuditLog`, data, { observe: 'response' });
    }
}



// WEBPACK FOOTER //
// ./client/app/internal/accmgr/services/internal-audit-logger.service.ts